import React, { useEffect, useState } from 'react';
import TempleCard from '../components/TempleCard';
import { getTemples } from '../services/api';
import { Flower } from 'lucide-react';

const Temples = () => {
  const [temples, setTemples] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTemples = async () => {
      const data = await getTemples();
      setTemples(data);
      setLoading(false);
    };
    fetchTemples();
  }, []);

  return (
    <div className="bg-stone-50 min-h-screen pt-12 pb-24 border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex justify-center mb-4">
            <div className="bg-saffron-100 p-3 rounded-full">
              <Flower className="h-8 w-8 text-saffron-600" />
            </div>
          </div>
          <h1 className="text-4xl font-extrabold text-stone-900 tracking-tight mb-4">
            <span className="text-saffron-600">नाथ नगरी</span> के मंदिर
          </h1>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            उन सात प्राचीन मंदिरों की खोज करें जो बरेली को इसकी आध्यात्मिक पहचान देते हैं। इतिहास पढ़ें, समय देखें और अपनी यात्रा की योजना बनाएं।
          </p>
        </div>

        {/* Grid */}
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[1, 2, 3, 4, 5, 6].map((n) => (
              <div key={n} className="bg-white rounded-2xl h-[400px] border border-stone-100 shadow-sm animate-pulse flex flex-col">
                <div className="h-56 bg-stone-200 rounded-t-2xl"></div>
                <div className="p-5 flex-1 space-y-3">
                  <div className="h-6 bg-stone-200 rounded w-1/3"></div>
                  <div className="h-4 bg-stone-200 rounded w-1/4"></div>
                  <div className="space-y-2 mt-4 text-sm text-stone-600">
                    <div className="h-4 bg-stone-200 rounded w-full"></div>
                    <div className="h-4 bg-stone-200 rounded w-5/6"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {temples.map((temple, index) => (
              <TempleCard key={temple.id} temple={temple} index={index} />
            ))}
          </div>
        )}

      </div>
    </div>
  );
};

export default Temples;
